import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HubioLoginService } from '@hubio/hubio-login';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  public displayName: string;
  public pageTitle: string;
  // @Input() homepageRoute = '';

  constructor(
    private auth: HubioLoginService,
    private router: Router
  ) {
    this.pageTitle = 'Hubio';
  }

  ngOnInit(): void {
    this.displayName = this.auth.getCurrentUserTokenDecoded()?.email;
    this.auth.accessToken$.subscribe((token) => {
      this.displayName = token?.email;
    })
  }

  logout() {
    this.auth.logout();
  }

  navigateHome() {
    this.router.navigate(['/']);
  }
}
